<template>
  <div>
    <div class="columns is-mobile mt-5 mb-0">
      <div :style="cuneistyle" class="column is-size-1">
        {{ sign.cuneiform }}
      </div>
      <div class="column">
        <div class="is-size-3">
          <trans-literal :word="sign.name" />
        </div>
      </div>
      <div class="column is-half-mobile" style="color: black">
        <div>
          Labat/ABZ:<b> {{ sign.labat }}</b>
        </div>
        <div v-if="page">
          Labat Page:
          <a :href="url" target="_blank"
            ><b>p.{{ page.page }}</b></a
          >
        </div>
        <div>
          MesZL: <b>{{ sign.meszl }}</b>
        </div>
        <div>
          <a :href="eBLUrl" target="_blank">eBL SignList</a>
        </div>
        <div v-if="wiktionaryUrl">
          <a :href="wiktionaryUrl" target="_blank">Wiktionary</a></a>
        </div>
      </div>
    </div>
    <div>
      <p>
        <span
          style="display: inline-block"
          class="mx-1"
          v-for="name in sign.alt_names"
        >
          <trans-literal :word="name" />
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import TransLiteral from "./TransLiteral.vue";
const labat = require("@/data/labat.json");
export default Vue.extend({
  name: "SignInfo",
  props: {
    sign: { required: true },
    cuneistyle: { required: true },
  },
  components: {
    TransLiteral,
  },
  computed: {
    page() {
      const page = labat[this.sign.labat];
      console.log(page);
      return page;
    },
    url() {
      return `https://archive.org/details/LabatR.ManuelDEpigraphieAkkadienne5Ed1976/page/n${
        Number(this.page.offset) + 34
      }/mode/1up`;
    },
    eBLUrl() {
      let value = this.sign.name;
      value = value.replace(/0/g, "₀");
      value = value.replace(/1/g, "₁");
      value = value.replace(/2/g, "₂");
      value = value.replace(/3/g, "₃");
      value = value.replace(/4/g, "₄");
      value = value.replace(/5/g, "₅");
      value = value.replace(/6/g, "₆");
      value = value.replace(/7/g, "₇");
      value = value.replace(/8/g, "₈");
      value = value.replace(/9/g, "₉");
      value = value.replace(/ x /g, "×");
      value = value.replace(/x/g, "ₓ");
      value = value.replace(/Ḫ/g, "H");
      
      if (value.includes("×")) {
        value = "%7c" + value + "%7c";
      }

      return `https://www.ebl.uni-muenchen.de/signs/${value}`;
    },
    wiktionaryUrl() {
      function getGraphemeCount(str) {
        const segmenter = new Intl.Segmenter("ja-JP", { granularity: "grapheme" });
        return [...segmenter.segment(str)].length;
      }

      if (getGraphemeCount(this.sign.cuneiform) == 1) {
        return `https://en.wiktionary.org/wiki/${this.sign.cuneiform}`;
      } else return null;
    },
  },
});
</script>
